<!--- View principal - Responsável Por renderizar a barra lateral e superior. --->

<template>
  <div class="w-full h-screen flex">
    <Sidebar />
    <div
      class="flex flex-column w-full hidden-on-print"
      style="margin-left: 72px; max-width: calc(100% - 75px)"
    >
      <NavbarLayout />
      <div
        class="w-full when-print bg-neutral-100"
        ref="mainScroll"
        style="height: calc(100vh - 72px)"
      >
        <router-view />
      </div>
    </div>

    <v-warehouse-notifications-modal :notifications="notifications" />
    <v-checkterm-modal
      :checkedPolicy="checkedPolicy"
      :checkedTerm="checkedTerm"
    />
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
    Sidebar: () => import('@/modules/designSystem/layouts/Sidebar'),
    NavbarLayout: () => import('@/modules/designSystem/layouts/NavbarLayout'),
    'v-warehouse-notifications-modal': () =>
      import('../components/Warehouse/WarehouseNotificationsModal'),
    'v-checkterm-modal': () => import('@/components/General/CheckTermModal')
  },
  async mounted() {
    this.eventHub.$on('attendance-opened', attendanceData => {
      if (
        attendanceData !== null &&
        typeof attendanceData.patient_id !== 'undefined' &&
        typeof attendanceData.id !== 'undefined'
      ) {
        const attendancePath =
          '/pacientes/' +
          attendanceData.patient_id +
          '/consulta/' +
          attendanceData.id
        if (this.$router.currentRoute.path !== attendancePath) {
          this.$router.push(attendancePath).catch(err => {
            // Handle navigation errors silently
            if (err.name !== 'NavigationDuplicated') {
              console.warn('Navigation error:', err)
            }
          })
        }
      }
    })
    this.getWarehouseNotifications()
    this.getCheckTerms()

    setTimeout(() => {
      window.Beamer && !window.Beamer.initialized && window.Beamer.init()
    }, 3000)
  },
  data() {
    return {
      notifications: [],
      routePath: window.location.pathname,
      checkedTerm: true,
      checkedPolicy: true,
      url: window.location.host
    }
  },
  methods: {
    getWarehouseNotifications() {
      const clinic = JSON.parse(localStorage.getItem('clinic'))
      this.api
        .getWarehouseNotifications(clinic.id)
        .then(({ data }) => {
          if (data.length) {
            this.notifications = data
            this.$bvModal.show('warehouse-notifications')
          }
        })
        .catch(err => {
          console.log('Error loading warehouse notifications', err)
        })
    },
    getCheckTerms() {
      this.api
        .checkTerms()
        .then(({ data }) => {
          this.checkedTerm = data.checkedTerm
          this.checkedPolicy = data.checkedPolicy
          if (!this.checkedTerm || !this.checkedPolicy) {
            this.$bvModal.show('check-term-modal')
          }
        })
        .catch(err => {
          console.log('Error check terms', err)
        })
    }
  },
  watch: {
    $route(from) {
      this.routePath = from.path
    }
  }
}
</script>
